// © Microsoft Corporation. All rights reserved.

import { ComponentStyles } from "@microsoft/fast-jss-manager";
import { DesignSystem, neutralForegroundRest, isDarkMode } from "@microsoft/fast-components-styles-msft";
import { SearchBoxClassNameContract } from "./SearchBox.classnames";
import { ColumnArrangement, getMediaQuerySelectorFor } from "@msnews/experiences-base";
import { directionSwitch } from "@microsoft/fast-jss-utilities";
/**
 * The search box component styles
 * @type {ComponentStyles<FeedNavigationClassNameContract, DesignSystem>}
 */
export const SearchBoxStyles: Partial<ComponentStyles<SearchBoxClassNameContract, DesignSystem>> = (config: DesignSystem) => {
    return {
        searchBox: {
            "& msft-search-box::part(root)": {
                [getMediaQuerySelectorFor(ColumnArrangement.c1)]: {
                    width: "273px"
                },
                [getMediaQuerySelectorFor(ColumnArrangement.c2)]: {
                    width: "542px"
                },
                [getMediaQuerySelectorFor(ColumnArrangement.c3)]: {
                    width: "530px"
                },
                [getMediaQuerySelectorFor(ColumnArrangement.c4)]: {
                    width: "710px"
                },
                "@media (min-width: 1920px)": {
                    width: "710px"
                },
                "max-width": "710px"
            },
            "& .voiceSearchButton": {
                background: isDarkMode(config) ? "#4a4a4a" : "#fff",
                border: "none",
                position: "absolute",
                height: "44px",
                width: "20px",
                padding: "0",
                left: directionSwitch("initial", "70px"),
                right: directionSwitch("70px", "initial"),
                "z-index": "2"
            }
        },
        searchHidden: {
            visibility: "hidden"
        },
        fakeCursor: {
            background: neutralForegroundRest,
            bottom: "14px",
            margin: "0 2px",
            position: "absolute",
            top: "14px",
            visibility: "hidden",
            width: "1px"
        },
        searchBingLogo: {
            margin: "12px 0",
            height: "20px",
            width: "14px",
            position: "absolute",
            left: directionSwitch("initial", "70px"),
            right: directionSwitch("70px", "initial")
        },
        voiceSearchSvg: {
            cursor: "pointer",
            height: "20px",
            width: "20px"
        }
    };
};